import React from 'react';
//import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NormalImg from '../common/Img';
import LogoImg from '../participants/bicamsinlogo.jpg';
import Button from '../common/Button';
import ExaminerTextBlock from './ExaminerTextBlock';
import SDMTTest from './SDMTTest';
import IconBulb from '../../assets/img/icon-bulb.png';
import IconMic from '../../assets/img/icon-mic.png';
import '../../assets/css/sdmt.css';

const Img = styled(NormalImg)`
  width: 200px;
  margin: 20px;
  display: block;
`;
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;

class AcuityTestPage extends React.Component {

  state = {
    pageStep: 1
  }
handleClick =(e) =>{
   this.setState({ pageStep: 2 });
}

render() {
        //console.log();

        const viewAcuity = (
                    <div className="row">
                    <div className="col-md-12">
                    <h1>Acuity Function</h1>   

                    <ExaminerTextBlock 
                      boxmode="panel panel-info" boxicon={IconBulb}>
                      <p>On the participant iPad tap the 'Start Acuity Test' button and place in front of the participant.</p>
                    </ExaminerTextBlock>   
                    <ExaminerTextBlock 
                      boxmode="panel panel-success"  boxicon={IconMic}>
                      <p>Cras congue quam leo, non tincidunt nisi commodo ac. Mauris elementum mollis neque, sed sollicitudin massa iaculis at. Pellentesque in magna nunc. </p>
                    </ExaminerTextBlock> 
                    <ExaminerTextBlock 
                      boxmode="panel panel-info"  boxicon={IconBulb} >
                      <p>As the participant says a number tap the corresponding number below</p>
                    </ExaminerTextBlock> 

                    <SDMTTest mode="demo" />

                    <ExaminerTextBlock 
                      boxmode="panel panel-info"  boxicon={IconBulb} >
                      <p>If satisfied the participant is suitable to continue, click on 'Next Screen' button below and tap 'Next' on the participant screen. If you feel the particpant is unsuitable tab the 'logout' button avove to end the assesment.</p>
                      </ExaminerTextBlock> 

                    <ButtonA className="btn btn-lg" onClick={this.handleClick}>Next Screen</ButtonA>
                    </div>
                    </div>
                    );
        
        const viewDexterity = (
                    <div className="row">
                    <div className="col-md-12">
                    <h1>Dexterity Function</h1>   

                    <ExaminerTextBlock 
                      boxmode="panel panel-info" boxicon={IconBulb}>
                      <p>Show the shapes on the participant iPad and read out the instructions below.</p>
                    </ExaminerTextBlock>   
                    <ExaminerTextBlock 
                      boxmode="panel panel-success"  boxicon={IconMic}>
                      <p>Please draw the shapes you can see on the top of the sceen in the blank space below.</p>
                      <p><em>(indicate on the participant screen)</em>.</p>
                      <p>You can see a pencil icon, tap that and draw the shapes</p>
                      <p>You can see an eraser icon, tap that to rub out any lines</p>
                    </ExaminerTextBlock> 
                  
                    <ExaminerTextBlock 
                      boxmode="panel panel-info"  boxicon={IconBulb} >
                      <p>Once the participant has finished drawing, compare the original shapes against what the participant has drawn to determine whether they are suitable. If the participant doesn't use the eraser demonstrate its use</p>
                      <p>Clien on the button below and press next on the participant iPad to continue.</p>
                      </ExaminerTextBlock> 

                    <Link to="/sdmt_test"><ButtonA className="btn btn-lg">Next Screen</ButtonA></Link>
                    </div>
                    </div>
                    );            


        return (
            <div className="normalPage">
               <div className="container"> 

                   <div className="row">
                        <div className="col-xs-6">
                        <Img src={LogoImg} alt="Bicams Logo" />
                        </div>
                        <div className="col-xs-6">
                        
                        
                        <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
                        </div>
                    </div>  

                    {this.state.pageStep === 2 ? viewDexterity  : viewAcuity}
           

               </div> 
            </div>
        );
    }

}

export default AcuityTestPage;


// WEBPACK FOOTER //
// ./src/components/exam/AcuityTestPage.js